import { Divider } from 'primereact/divider';
import React from 'react';
import { FloatLabel } from 'primereact/floatlabel';
import AutoFocusDropdown from '../../../../../components/AutoFocusDropdown';
import { classNames } from 'primereact/utils';
import { InputText } from 'primereact/inputtext';
import { InputNumber } from 'primereact/inputnumber';
import SeleccionarDepartamento from '../../../../../components/SeleccionarDepartamento';
import SeleccionarDistrito from '../../../../../components/SeleccionarDistrito';
import SeleccionarLocalidad from '../../../../../components/SeleccionarLocalidad';

const GCamAE = (props) => {
    const natVen = [
        {
            i_nat_ven: 1,
            d_des_nat_ven: 'No contribuyente'
        },
        {
            i_nat_ven: 2,
            d_des_nat_ven: 'Extranjero'
        }
    ];

    const tipoDocVen = [
        {
            i_tip_id_ven: 1,
            dd_tip_id_ven: 'Cédula paraguaya'
        },
        {
            i_tip_id_ven: 2,
            dd_tip_id_ven: 'Pasaporte'
        },
        {
            i_tip_id_ven: 3,
            dd_tip_id_ven: 'Cédula extranjera'
        },
        {
            i_tip_id_ven: 4,
            dd_tip_id_ven: 'Carnet de residencia'
        }
    ];
    return (
        <div className="p-fluid formgrid grid">
            <Divider align="center">
                <b>Campos que componen la Autofactura electrónica</b>
            </Divider>
            <div className="field col-12 md:col-4">
                <FloatLabel>
                    <AutoFocusDropdown
                        id="naturalezaVendedor"
                        dataTestId="naturalezaVendedor"
                        tooltip="Naturaleza del vendedor"
                        checkmark={true}
                        value={props.formik.values.nat_ven}
                        onChange={(e) => props.formik.setFieldValue('nat_ven', e.value)}
                        onBlur={() => props.formik.setFieldTouched('nat_ven', true)}
                        options={natVen}
                        optionLabel="d_des_nat_ven"
                        placeholder="Seleccione la naturaleza del vendedor"
                        className={classNames({ 'p-invalid': props.isFormFieldInvalid('nat_ven') })}
                    />
                    <label htmlFor="monedaTipoPago">Naturaleza del vendedor</label>
                    {props.getFormErrorMessage('nat_ven')}
                </FloatLabel>
            </div>
            <div className="field col-12 md:col-4">
                <FloatLabel>
                    <AutoFocusDropdown
                        id="tipoDocVendedor"
                        dataTestId="tipoDocVendedor"
                        tooltip="Tipo de documento del vendedor"
                        checkmark={true}
                        value={props.formik.values.tipo_doc_ven}
                        onChange={(e) => props.formik.setFieldValue('tipo_doc_ven', e.value)}
                        onBlur={() => props.formik.setFieldTouched('tipo_doc_ven', true)}
                        options={tipoDocVen}
                        optionLabel="dd_tip_id_ven"
                        placeholder="Seleccione el tipo de documento del vendedor"
                        className={classNames({ 'p-invalid': props.isFormFieldInvalid('tipo_doc_ven') })}
                    />
                    <label htmlFor="tipoDocVendedor"> Tipo de documento del vendedor</label>
                    {props.getFormErrorMessage('tipo_doc_ven')}
                </FloatLabel>
            </div>
            <div className="field col-12 md:col-4">
                <FloatLabel>
                    <InputText
                        id="docIDVen"
                        data-testid="docIDVen"
                        type="text"
                        value={props.formik.values.d_num_id_ven}
                        onChange={(e) => props.formik.setFieldValue('d_num_id_ven', e.target.value)}
                        onBlur={() => props.formik.setFieldTouched('d_num_id_ven', true)}
                        className={classNames({ 'p-invalid': props.isFormFieldInvalid('d_num_id_ven') })}
                    />
                    <label htmlFor="docIDVen">Documento de identidad del vendedor</label>
                    {props.getFormErrorMessage('d_num_id_ven')}
                </FloatLabel>
            </div>
            <div className="field col-12 md:col-4">
                <FloatLabel>
                    <InputText
                        id="nombreVen"
                        data-testid="nombreVen"
                        type="text"
                        value={props.formik.values.d_nom_ven}
                        onChange={(e) => props.formik.setFieldValue('d_nom_ven', e.target.value)}
                        onBlur={() => props.formik.setFieldTouched('d_nom_ven', true)}
                        className={classNames({ 'p-invalid': props.isFormFieldInvalid('d_nom_ven') })}
                    />
                    <label htmlFor="nombreVen">Nombre y apellido del vendedor</label>
                    {props.getFormErrorMessage('d_nom_ven')}
                </FloatLabel>
            </div>
            <div className="field col-12 md:col-4">
                <FloatLabel>
                    <InputText
                        id="dirVen"
                        data-testid="dirVen"
                        type="text"
                        value={props.formik.values.d_dir_ven}
                        onChange={(e) => props.formik.setFieldValue('d_dir_ven', e.target.value)}
                        onBlur={() => props.formik.setFieldTouched('d_dir_ven', true)}
                        className={classNames({ 'p-invalid': props.isFormFieldInvalid('d_dir_ven') })}
                    />
                    <label htmlFor="dirVen">Dirección del vendedor</label>
                    {props.getFormErrorMessage('d_dir_ven')}
                </FloatLabel>
            </div>
            <div className="field col-12 md:col-2">
                <FloatLabel>
                    <InputNumber
                        id="nroCasaVen"
                        data-testid="nroCasaVen"
                        type="text"
                        locale="es-PY"
                        minFractionDigits={0}
                        value={props.formik.values.d_num_cas_ven}
                        onChange={(e) => {
                            props.formik.setFieldValue('d_num_cas_ven', e.value);
                        }}
                        onBlur={() => props.formik.setFieldTouched('d_num_cas_ven', true)}
                        className={classNames({ 'p-invalid': props.isFormFieldInvalid('d_num_cas_ven') })}
                    />
                    <label htmlFor="nroCasaVen">Nro. casa del vendedor</label>
                    {props.getFormErrorMessage('d_num_cas_ven')}
                </FloatLabel>
            </div>
            <div className="field col-12 md:col-4">
                <FloatLabel>
                    <SeleccionarDepartamento
                        id="dptoVen"
                        dataTestId="dptoVen"
                        value={props.formik.values.departamento_ven}
                        onChange={(e) => props.formik.setFieldValue('departamento_ven', e.value)}
                        onBlur={() => props.formik.setFieldTouched('departamento_ven', true)}
                        skeletonHeigh={'3rem'}
                        className={classNames({ 'p-invalid': props.isFormFieldInvalid('departamento_ven') })}
                    />
                    <label htmlFor="dptoVen">Departamento del vendedor</label>
                    {props.getFormErrorMessage('departamento_ven')}
                </FloatLabel>
            </div>
            <div className="field col-12 md:col-4">
                <FloatLabel>
                    <SeleccionarDistrito
                        id="distVen"
                        dataTestId="distVen"
                        departamento={props.formik.values.departamento_ven?.codigo}
                        value={props.formik.values.distrito_ven}
                        onChange={(e) => props.formik.setFieldValue('distrito_ven', e.target.value)}
                        onBlur={() => props.formik.setFieldTouched('distrito_ven', true)}
                        skeletonHeigh={'3rem'}
                        className={classNames({ 'p-invalid': props.isFormFieldInvalid('distrito_ven') })}
                    />
                    <label htmlFor="distVen">Distrito del vendedor</label>
                    {props.getFormErrorMessage('distrito_ven')}
                </FloatLabel>
            </div>
            <div className="field col-12 md:col-4">
                <FloatLabel>
                    <SeleccionarLocalidad
                        id="localidadVen"
                        dataTestId="localidadVen"
                        distrito={props.formik.values.distrito_ven?.codigo}
                        value={props.formik.values.localidad_ven}
                        onChange={(e) => props.formik.setFieldValue('localidad_ven', e.target.value)}
                        onBlur={() => props.formik.setFieldTouched('localidad_ven', true)}
                        skeletonHeigh={'3rem'}
                        className={classNames({ 'p-invalid': props.isFormFieldInvalid('localidad_ven') })}
                    />
                    <label htmlFor="localidadVen">Localidad del vendedor</label>
                    {props.getFormErrorMessage('localidad_ven')}
                </FloatLabel>
            </div>
            <div className="field col-12 md:col-4">
                <FloatLabel>
                    <InputText
                        id="dirTranc"
                        data-testid="dirTranc"
                        type="text"
                        value={props.formik.values.d_dir_prov}
                        onChange={(e) => props.formik.setFieldValue('d_dir_prov', e.target.value)}
                        onBlur={() => props.formik.setFieldTouched('d_dir_prov', true)}
                        className={classNames({ 'p-invalid': props.isFormFieldInvalid('d_dir_prov') })}
                    />
                    <label htmlFor="dirTranc">Dirección en donde se realiza la transacción</label>
                    {props.getFormErrorMessage('d_dir_prov')}
                </FloatLabel>
            </div>
            <div className="field col-12 md:col-4">
                <FloatLabel>
                    <SeleccionarDepartamento
                        id="dptoTrans"
                        dataTestId="dptoTrans"
                        value={props.formik.values.departamento_prov}
                        onChange={(e) => props.formik.setFieldValue('departamento_prov', e.value)}
                        onBlur={() => props.formik.setFieldTouched('departamento_prov', true)}
                        skeletonHeigh={'3rem'}
                        className={classNames({ 'p-invalid': props.isFormFieldInvalid('departamento_prov') })}
                    />
                    <label htmlFor="dptoTrans">Departamento en donde se realiza la transacción</label>
                    {props.getFormErrorMessage('departamento_prov')}
                </FloatLabel>
            </div>
            <div className="field col-12 md:col-4">
                <FloatLabel>
                    <SeleccionarDistrito
                        id="distTrans"
                        dataTestId="distTrans"
                        departamento={props.formik.values.departamento_prov?.codigo}
                        value={props.formik.values.distrito_prov}
                        onChange={(e) => props.formik.setFieldValue('distrito_prov', e.target.value)}
                        onBlur={() => props.formik.setFieldTouched('distrito_prov', true)}
                        skeletonHeigh={'3rem'}
                        className={classNames({ 'p-invalid': props.isFormFieldInvalid('distrito_prov') })}
                    />
                    <label htmlFor="distTrans">Distrito en donde se realiza la transacción</label>
                    {props.getFormErrorMessage('distrito_prov')}
                </FloatLabel>
            </div>
            <div className="field col-12 md:col-4">
                <FloatLabel>
                    <SeleccionarLocalidad
                        id="localidadTrans"
                        dataTestId="localidadTrans"
                        distrito={props.formik.values.distrito_prov?.codigo}
                        value={props.formik.values.localidad_prov}
                        onChange={(e) => props.formik.setFieldValue('localidad_prov', e.target.value)}
                        onBlur={() => props.formik.setFieldTouched('localidad_prov', true)}
                        skeletonHeigh={'3rem'}
                        className={classNames({ 'p-invalid': props.isFormFieldInvalid('localidad_prov') })}
                    />
                    <label htmlFor="localidadTrans">Localidad en donde se realiza la transacción</label>
                    {props.getFormErrorMessage('localidad_prov')}
                </FloatLabel>
            </div>
        </div>
    );
};

export default GCamAE;
